import React, { createContext, useContext, useState } from 'react';

const SubmissionLimitSettingContext = createContext();

export const SubmissionLimitSettingProvider = ({ children }) => {
    const [limitSetting, setLimitSetting] = useState(null);

    const handleChangeLimitSetting = (data) => {
        setLimitSetting(data);
    };

    return (
        <SubmissionLimitSettingContext.Provider value={{ limitSetting, handleChangeLimitSetting }}>
            {children}
        </SubmissionLimitSettingContext.Provider>
    );
};

export const useSubmissionLimitSetting = () => {
    return useContext(SubmissionLimitSettingContext);
};
